export default "__VITE_ASSET__CfbzgViv__"